var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkdein(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0C7.21566 0 0.5 6.71567 0.5 15C0.5 23.2843 7.21566 30 15.5 30C23.7843 30 30.5 23.2843 30.5 15C30.4999 6.71567 23.7842 0 15.5 0ZM11.4979 22.2518H8.20455V11.6118H11.4979V22.2518ZM9.83556 10.2184C8.75997 10.2184 7.88802 9.33931 7.88802 8.25511C7.88802 7.17078 8.76009 6.29178 9.83556 6.29178C10.911 6.29178 11.783 7.17078 11.783 8.25511C11.783 9.33937 10.9111 10.2184 9.83556 10.2184ZM23.8399 22.2518H20.5625V16.6667C20.5625 15.1348 19.9807 14.2797 18.7694 14.2797C17.4511 14.2797 16.7624 15.1703 16.7624 16.6667V22.2518H13.6037V11.6118H16.7624V13.0448C16.7624 13.0448 17.7126 11.2872 19.9687 11.2872C22.2249 11.2872 23.84 12.6648 23.84 15.5147L23.8399 22.2518Z",
    fill: "url(#paint0_linear_40_668)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_40_668",
    x1: 4.89338,
    y1: 4.39339,
    x2: 26.1066,
    y2: 25.6066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2489BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0575B3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdein);
export default __webpack_public_path__ + "static/media/linkdein.861f1733d911522752f6f4a0f962fa4e.svg";
export { ForwardRef as ReactComponent };